import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { LayoutSingleColumn } from '../LayoutComposer';
import Page from '../Page/Page';

const StatusPage = props => {
  const { schemaTitle, schemaDescription, ogImage, children } = props;
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={false}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
      socialSharing={{ images1200: ogImage }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        {children}
      </LayoutSingleColumn>
    </Page>
  );
};

export default StatusPage;
